import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

export interface UpdateDestinatarioProps {
  ativo: boolean;
  frequencia: number;
  diaSemana: number;
  horarios: string[];
}

export default function useUpdateNotificacoes() {
  return useMutation(
    URL.RECURRING_JOB_GROUP.ATUALIZAR("id"),
    async (body: UpdateDestinatarioProps) => {
      const response = await http.put(URL.CONFIGURACAO_NOTIFICACOES.OBTER, body);
      return response;
    },
  );
}
